import { toaster } from '@welbe/design-system';

export const handleToast = (
	type: 'success' | 'error',
	title?: string,
	description?: string,
) => {
	toaster.create({
		type,
		title: title || 'Hubo un error al realizar esta acción',
		description: description || '',
	});
};
